// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"332b08f1","488":"9dbfb216","699":"99bb404b","706":"9da9238c","815":"98b7070b"}[chunkId] + ".chunk.css";
};